// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QISg","input":"styles_input__2LJuD"};